/* eslint-disable @typescript-eslint/no-explicit-any */
import axiosApiInstance from '@/api/axios'
import {
  LicenseVersionModel,
  LicenseVersionsPricesModel,
  LicenseVersionsProductModel,
  LicenseVersionsWithOptionsModel,
} from './models/LicenseVersionsModel'
import { LICENSES_ENDPOINTS } from '@/modules/LicensesPage/api/api'

class LicenseVersionsService {
  async createPrices(data: LicenseVersionsPricesModel): Promise<any> {
    const res = await axiosApiInstance.post(
      `/LicenseVersions/price/withOptions`,
      data,
    )
    return res.data
  }

  async getDeviceSerial(
    deviceNumber: string,
  ): Promise<LicenseVersionsProductModel[]> {
    const res = await axiosApiInstance.get(
      `/LicenseVersions/DeviceSerial/${deviceNumber}`,
    )
    return res.data
  }

  async getLicenseVersionsById(id: string): Promise<LicenseVersionModel> {
    const res = await axiosApiInstance.get(`/LicenseVersions/${id}`)
    return res.data
  }

  async getLicenseVersionsByFilter(
    filter: any,
  ): Promise<LicenseVersionModel[]> {
    const res = await axiosApiInstance.post(
      `${LICENSES_ENDPOINTS.LICENSES_VERSIONS}/byFilter`,
      filter,
    )
    return res.data.collection || []
  }

  async licenseVersionsPriceWithOptions(
    data: LicenseVersionsPricesModel,
  ): Promise<LicenseVersionsWithOptionsModel> {
    const res = await axiosApiInstance.post(
      `/LicenseVersions/price/withOptions`,
      data,
    )
    return res.data
  }
}

export default new LicenseVersionsService()
